import { AttributeType, gl } from '@antv/l7-core';
export let ShaderLocation = /*#__PURE__*/function (ShaderLocation) {
  ShaderLocation[ShaderLocation["POSITION"] = 0] = "POSITION";
  ShaderLocation[ShaderLocation["COLOR"] = 1] = "COLOR";
  ShaderLocation[ShaderLocation["VERTEX_ID"] = 2] = "VERTEX_ID";
  ShaderLocation[ShaderLocation["PICKING_COLOR"] = 3] = "PICKING_COLOR";
  ShaderLocation[ShaderLocation["STROKE"] = 4] = "STROKE";
  ShaderLocation[ShaderLocation["OPACITY"] = 5] = "OPACITY";
  ShaderLocation[ShaderLocation["OFFSETS"] = 6] = "OFFSETS";
  ShaderLocation[ShaderLocation["ROTATION"] = 7] = "ROTATION";
  ShaderLocation[ShaderLocation["EXTRUSION_BASE"] = 8] = "EXTRUSION_BASE";
  ShaderLocation[ShaderLocation["SIZE"] = 9] = "SIZE";
  ShaderLocation[ShaderLocation["SHAPE"] = 10] = "SHAPE";
  ShaderLocation[ShaderLocation["EXTRUDE"] = 11] = "EXTRUDE";
  ShaderLocation[ShaderLocation["MAX"] = 12] = "MAX";
  ShaderLocation[ShaderLocation["NORMAL"] = 13] = "NORMAL";
  ShaderLocation[ShaderLocation["UV"] = 14] = "UV";
  ShaderLocation[ShaderLocation["LINEAR"] = 15] = "LINEAR";
  return ShaderLocation;
}({}); // Polygon Linear
export function getCommonStyleAttributeOptions(name) {
  switch (name) {
    // // roate
    case 'rotation':
      return {
        name: 'Rotation',
        type: AttributeType.Attribute,
        descriptor: {
          name: 'a_Rotation',
          shaderLocation: ShaderLocation.ROTATION,
          buffer: {
            usage: gl.DYNAMIC_DRAW,
            data: [],
            type: gl.FLOAT
          },
          size: 1,
          update: feature => {
            const {
              rotation = 0
            } = feature;
            return Array.isArray(rotation) ? [rotation[0]] : [rotation];
          }
        }
      };
    case 'stroke':
      return {
        name: 'stroke',
        type: AttributeType.Attribute,
        descriptor: {
          name: 'a_Stroke',
          shaderLocation: ShaderLocation.STROKE,
          buffer: {
            // give the WebGL driver a hint that this buffer may change
            usage: gl.DYNAMIC_DRAW,
            data: [],
            type: gl.FLOAT
          },
          size: 4,
          update: feature => {
            const {
              stroke = [1, 1, 1, 1]
            } = feature;
            return stroke;
          }
        }
      };
    case 'opacity':
      return {
        name: 'opacity',
        type: AttributeType.Attribute,
        descriptor: {
          name: 'a_Opacity',
          shaderLocation: ShaderLocation.OPACITY,
          buffer: {
            // give the WebGL driver a hint that this buffer may change
            usage: gl.STATIC_DRAW,
            data: [],
            type: gl.FLOAT
          },
          size: 1,
          update: feature => {
            const {
              opacity: op = 1
            } = feature;
            return [op];
          }
        }
      };
    case 'extrusionBase':
      return {
        name: 'extrusionBase',
        type: AttributeType.Attribute,
        descriptor: {
          name: 'a_ExtrusionBase',
          shaderLocation: ShaderLocation.EXTRUSION_BASE,
          buffer: {
            // give the WebGL driver a hint that this buffer may change
            usage: gl.STATIC_DRAW,
            data: [],
            type: gl.FLOAT
          },
          size: 1,
          update: feature => {
            const {
              extrusionBase: op = 0
            } = feature;
            return [op];
          }
        }
      };
    case 'offsets':
      return {
        name: 'offsets',
        type: AttributeType.Attribute,
        descriptor: {
          name: 'a_Offsets',
          shaderLocation: ShaderLocation.OFFSETS,
          buffer: {
            // give the WebGL driver a hint that this buffer may change
            usage: gl.STATIC_DRAW,
            data: [],
            type: gl.FLOAT
          },
          size: 2,
          update: feature => {
            const {
              offsets: epo
            } = feature;
            return epo;
          }
        }
      };
    case 'thetaOffset':
      return {
        name: 'thetaOffset',
        type: AttributeType.Attribute,
        descriptor: {
          name: 'a_ThetaOffset',
          shaderLocation: 15,
          buffer: {
            // give the WebGL driver a hint that this buffer may change
            usage: gl.STATIC_DRAW,
            data: [],
            type: gl.FLOAT
          },
          size: 1,
          update: feature => {
            const {
              thetaOffset: op = 1
            } = feature;
            return [op];
          }
        }
      };
    default:
      return undefined;
  }
}